import { useLocale, useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { LUXON_STORE_TIME_HOUR_FORMAT_MAP } from '@constants/constants'
import { getStoreOpenCloseStatusForDate } from '@lib/store-hours-utils'

type UseStoreHoursProps = Parameters<typeof getStoreOpenCloseStatusForDate>[0]

export const useStoreOpenCloseStatus = (props: UseStoreHoursProps) => {
  const t = useTranslations()
  const locale = useLocale()

  return useMemo(() => {
    const { isStoreOpen, storeStatus, closingDateTime, nextOpenDateTime } = getStoreOpenCloseStatusForDate(props)

    return {
      isStoreOpen,
      storeStatus,
      closingDateTime,
      nextOpenDateTime,
      storeStatusText: t(`global.store.status-${storeStatus}`),
      closingTimeText: closingDateTime
        ? t('global.store.status-until', {
            time: closingDateTime.toFormat(LUXON_STORE_TIME_HOUR_FORMAT_MAP[locale], { locale })
          })
        : null,
      nextOpenTimeText: nextOpenDateTime
        ? t('global.store.status-opens', {
            day: nextOpenDateTime.toFormat('cccc', { locale }),
            time: nextOpenDateTime.toFormat(LUXON_STORE_TIME_HOUR_FORMAT_MAP[locale], { locale })
          })
        : null
    }
  }, [t, locale, props.date.toMillis(), props.storeHours, props.storeHours.length, props.timeZone])
}
